import { render, staticRenderFns } from "./FireCauseExternOrigin.vue?vue&type=template&id=a50de612&scoped=true"
import script from "./FireCauseExternOrigin.vue?vue&type=script&lang=ts"
export * from "./FireCauseExternOrigin.vue?vue&type=script&lang=ts"
import style0 from "./FireCauseExternOrigin.vue?vue&type=style&index=0&id=a50de612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50de612",
  null
  
)

export default component.exports